__turbopack_context__.v({
  "periodSelect": "topCompaniesActions-module-scss-module__CUOnzW__periodSelect",
});
